import { createAppAsyncThunk } from "core/src/store/store.types";
import { BaseEtlImportSchema, EtlImport } from "etl/types";

type PatchEtlImportRequest = {
	uuid: string;
	data: Partial<EtlImport>;
};

export const patchEtlImport = createAppAsyncThunk<EtlImport, PatchEtlImportRequest>(
	"etlData/patchEtlImport",
	async (data, { extra }) => {
		const response = await extra.etlClient.update(BaseEtlImportSchema, data.uuid, data.data);
		return response.data;
	}
);
